import api from '../config/api';
import { useQuery } from 'react-query';

export const categoriesKeys = {
  tree: (includeInactive = false) => ['categories', 'tree', { includeInactive }],
  bySlug: (slug) => ['categories', 'slug', String(slug || '')],
  children: (id, includeInactive = false) => ['categories', 'children', String(id || ''), { includeInactive }]
};

export function useCategoriesTree({ includeInactive = false } = {}) {
  return useQuery(
    categoriesKeys.tree(includeInactive),
    async () => {
      const res = await api.get('/api/categories/tree', { params: includeInactive ? { includeInactive: 1 } : undefined });
      return res.data;
    },
    { staleTime: 5 * 60 * 1000 }
  );
}

export function useCategoryBySlug(slug) {
  return useQuery(
    categoriesKeys.bySlug(slug),
    async () => {
      const res = await api.get(`/api/categories/slug/${encodeURIComponent(slug)}`);
      return res.data;
    },
    { enabled: !!slug }
  );
}

export function useCategoryChildren(id, { includeInactive = false } = {}) {
  return useQuery(
    categoriesKeys.children(id, includeInactive),
    async () => {
      const res = await api.get(`/api/categories/${encodeURIComponent(id)}/children`, { params: includeInactive ? { includeInactive: 1 } : undefined });
      return res.data;
    },
    { enabled: !!id }
  );
}

